'use client'
import { useEffect, useState } from 'react'

const useInitNaverSdk = () => {
  const [isLoadScript, setIsLoadScript] = useState(false)
  const [isLoadError, setIsLoadError] = useState(false)

  useEffect(() => {
    if (window.naver) {
      setIsLoadScript(true)
      return
    }
    const naverScript = document.createElement('script')
    naverScript.async = true
    naverScript.type = 'text/javascript'
    naverScript.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.NEXT_PUBLIC_NAVER_MAPS_KEY}&submodules=geocoder`

    document.head.appendChild(naverScript)

    naverScript.onload = () => {
      if (window.naver) {
        setIsLoadScript(true)
      } else {
        setIsLoadScript(false)
      }
    }

    naverScript.onerror = () => {
      setIsLoadError(true)
    }
  }, [])

  if (isLoadError) {
    throw new Error(`지도를 불러오지 못했습니다.`)
  }

  return { isLoadScript }
}

export { useInitNaverSdk }
